// App Constants
export const ROUTES = {
  HOME: '/',
  SERVICES: '/services',
  ABOUT: '/about',
  CONTACT: '/contact',
  GALLERY: '/gallery',
};

export const NAV_ITEMS = [
  { path: ROUTES.HOME, label: 'Home' },
  { path: ROUTES.SERVICES, label: 'Services' },
  { path: ROUTES.ABOUT, label: 'About' },
  { path: ROUTES.GALLERY, label: 'Gallery' },
  { path: ROUTES.CONTACT, label: 'Contact' },
];

export const SCROLL_THRESHOLD = 50;

export const CONTACT_INFO = {
  email: 'Info@eventcoresolutions.co.za',
  phone: '0615136258',
  instagram: 'https://instagram.com/event_core_solutions',
};

export const BUSINESS_HOURS = {
  weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
  saturday: 'Saturday: 10:00 AM - 4:00 PM',
  sunday: 'Sunday: Closed',
};

